<content>
    <app-inc-consumos-list class="component" [consumoId]="consumoId" [consumoCampoId]="consumoCampoId"
        (mensaje)="pushMessage($event)" (consumosList)="consumosList=$event"
        (multipleConsumos)="multipleConsumos=$event">
    </app-inc-consumos-list>
    <app-incidencia id="big-modal" [incidenciaId]="incidenciaId" [consumosList]="consumosList" [multipleConsumos]="multipleConsumos"
        (mensaje)="pushMessage($event)" (closingMessage)="mensaje.emit($event)"
        (close)="close.emit($event)" (refresh)="refresh.emit($event)">
    </app-incidencia>
</content>
<app-toast *ngIf="(showWarning) && mensajes" [messages]="mensajes" (closed)="showWarning=$event"></app-toast>